import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const createUser = async (data: any) => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/users`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  return result;
};

export default createUser;
